import { Injectable } from '@angular/core';
import { BaseCrudService } from '../../../core/data/services/base-crud.service';
import Bank from '../../../core/data/models/bank.model';

@Injectable()
export class BankService extends BaseCrudService<Bank> {
  controller = 'Banks';
  getBanks() {
    return this.get<Bank[]>({});
  }
}
